var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex h-13" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-center bg-pure-white border-b border-slate-400",
          class: { "rounded-bl": _vm.isLast }
        },
        [
          _c(
            "div",
            { staticClass: "w-14 px-4 flex-shrink-0 rounded-tl" },
            [
              _c("BlInputCheck", {
                attrs: { checked: _vm.checked },
                on: {
                  changed: function($event) {
                    return _vm.$emit("change-selected")
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-112 flex-grow px-4 flex-shrink-0 flex items-center justify-between border-b border-slate-400",
          attrs: { title: _vm.document.filename }
        },
        [
          _c("BlTextBody2", {
            staticClass: "truncate",
            attrs: { text: _vm.document.filename }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-50 px-4 flex-shrink-0 flex items-center justify-between border-b border-slate-400"
        },
        [
          _c("BlTextBody2", {
            staticClass: "truncate",
            attrs: { text: _vm.displayDocumentType }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-50 px-4 flex-shrink-0 flex items-center justify-between border-b border-slate-400"
        },
        [
          _c("BlTextBody2", {
            attrs: { text: _vm.displayDate({ date: _vm.document.created_at }) }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-50 px-4 flex-shrink-0 flex items-center justify-between border-b border-slate-400"
        },
        [
          !_vm.document.user
            ? _c("BlTextBody2", {
                staticClass: "italic truncate",
                attrs: { title: "Deleted user", text: "Deleted user" }
              })
            : _c(
                "div",
                {
                  staticClass:
                    "h-8 px-3 rounded bg-success-100 flex items-center justify-center border border-success-100 truncate max-w-25",
                  attrs: { title: _vm.document.user.name }
                },
                [
                  _c("BlTextBody1", {
                    staticClass: "text-success truncate",
                    attrs: { text: _vm.document.user.name }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex sticky right-0 bg-pure-white" }, [
        _c(
          "div",
          {
            staticClass:
              "w-60 px-4 flex-shrink-0 bg-pure-white flex items-center justify-end gap-2 border-b border-slate-400",
            class: { "rounded-br": _vm.isLast }
          },
          [
            _c("BlInputButton", {
              attrs: { icon: "delete", type: "outlined-error", dense: "" },
              on: {
                clicked: function($event) {
                  _vm.deleteOpened = true
                }
              }
            }),
            _vm._v(" "),
            _c("BlInputButton", {
              attrs: {
                type: "outlined",
                dense: "",
                label: "Download",
                loading: _vm.downloadLoading
              },
              on: { clicked: _vm.onDownload }
            }),
            _vm._v(" "),
            _vm.isPreviewAvailable
              ? _c("BlInputButton", {
                  attrs: { type: "outlined", dense: "", label: "View" },
                  on: {
                    clicked: function($event) {
                      _vm.previewOpened = true
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete file",
              label: "Delete file",
              description:
                "<div class='break-words'>You are about to delete <b>" +
                _vm.document.filename +
                "</b> from your client. Are you sure you want to proceed? This action cannot be undone.</div>",
              type: "error",
              submitLoading: _vm.deleteLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onDelete
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.previewOpened
        ? _c("PreviewModal", {
            attrs: { document: _vm.document, checked: _vm.checked },
            on: {
              "change-selected": function($event) {
                return _vm.$emit("change-selected")
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              },
              "close-modal": function($event) {
                _vm.previewOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f28fb7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f28fb7d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/file/ItemList.vue
// module id = null
// module chunks = 